import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type AutoplayModuleSpecsFragment } from '../../../../api/fragments/AutoplayModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { useAutoplaySettingsDrawer } from './AutoplaySettingsDrawer';

export type AutoplaySettingsEmptyListProps = {
    module: AutoplayModuleSpecsFragment;
};

const AutoplaySettingsEmptyList = ({ module }: AutoplaySettingsEmptyListProps) => {
    const { t } = useTranslation(['autoplayModuleDetails']);
    const addAutoplaySettingsDrawer = useAutoplaySettingsDrawer(module.id);

    return (
        <>
            <NoItemResult
                extra={
                    <Button onClick={addAutoplaySettingsDrawer.open} type="primary">
                        {t('autoplayModuleDetails:emptyList.autoplaySettings.noData.action')}
                    </Button>
                }
                subTitle={t('autoplayModuleDetails:emptyList.autoplaySettings.noData.message')}
            />
            {addAutoplaySettingsDrawer.render()}
        </>
    );
};

export default AutoplaySettingsEmptyList;
